/** Match codes used by demo mode (kept dependency-free so routing can import them cheaply). */
export const DEMO_CODES = {
  running: 'WOLF42',
  lobby: 'MOON77',
  finished: 'OAK7ED',
  pending: 'FERN88',
} as const;
